import React from "react";

const Copyright = () => {
  return (
    <div className="copyright">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <p className="p-small">
              Copyright © 2022 <a href="https://github.com/lilyoo226">Samuel</a> - All
              rights reserved
            </p>
            <p className="p-small">
              Build By:{" "}
              <a href="https://github.com/lilyoo226" target="_blank">
                Samuel Amoah
              </a>
            </p>
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* enf of row */}
      </div>{" "}
      {/* end of container */}
    </div>
  );
};

export default Copyright;
